import React from "react";
import "./Divider.css";

const Divider = ({children , color="#000", backgroundcolor = "#fff", height="10px"}) => {
  return (
    <div className="divider" style={({color: color, backgroundColor: backgroundcolor, height: height})}>
      {children}
    </div>
  );
};

export default Divider;
